import React from 'react';
import {
  Switch,
  Route,
  useRouteMatch,
} from 'react-router-dom';

import {
  PagePlayersList,
  PagePlayer,
} from '../pages/players';

const RoutePlayers = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <PagePlayersList />
      </Route>
      <Route path={`${path}/:_id`}>
        <PagePlayer />
      </Route>
    </Switch>
  );
};

export default RoutePlayers;
